import styled, { css } from "styled-components";

import { consolePrimaryColor } from "pages/[tenant]/console/styles/consoleGlobalColors";

type CustomSelectProps = {
  isInvalid?: boolean;
};

export const CustomSelect = styled.div<CustomSelectProps>`
  .react-select__control {
    min-height: 36px;
    width: 8.5rem;
    border-radius: 4px;
    transition: 0.2s all;
    background: ${({ theme }) => theme.checkoutStepsOffers?.inputBackground};
    border: none;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__menu {
    background: ${({ theme }) => theme.checkoutStepsOffers?.cardBackground};
  }

  .react-select__option {
    background: ${({ theme }) => theme.checkoutStepsOffers?.cardBackground};
  }

  .react-select__control--is-focused {
    border: 1px solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a8`};
  }

  .react-select__option--is-focused {
    background-color: ${({ theme }) =>
      theme.console.sidebar.optionHoverBackgroundColor};
  }
`;
